<template>
  <div>
    <div class="min-h-screen dark:bg-black">
      <div class="container mx-auto px-8 py-2">
        <div class="mt-8">
          <div class="flex flex-col gap-8">
            <SplashStats :new-offer="newOffer" />
            <OfferView :offers="offers" />
          </div>
        </div>
      </div>
    </div>
    <GithubCorner />
  </div>
</template>

<script setup lang="ts">
import { Buffer } from 'buffer';
(window as any).Buffer = Buffer;

import { parseOffer } from '~/chia/offer-parser';

const offers = ref<any[]>([]);
const newOffer = ref<any>(null);

const isConnected = ref(false);

let socket: WebSocket | undefined;

onMounted(async () => {
  socket = new WebSocket('wss://api.coinset.org/ws');

  socket.onopen = () => {
    isConnected.value = true;
  };

  socket.onmessage = async (event) => {
    try {
      const eventJson = JSON.parse(event.data);
      console.log(eventJson);

      if (eventJson.type === 'offer') {
        const offer = { ...(await parseOffer(eventJson.data.offer)), timestamp: Date.now() };
        offers.value.unshift(offer);
        newOffer.value = offer;
      }
    } catch (e) {
      console.error(e);
    }
  };

  socket.onerror = (error) => {
    console.error('WebSocket error:', error);
  };

  socket.onclose = () => {
    isConnected.value = false;
  };
});

onUnmounted(() => {
  socket?.close();
});
</script>
